import {Beer} from 'typescript/models/Beer';
import Brewery from 'typescript/models/Brewery';

import TopBeer from './TopBeer/TopBeer';

interface ITopBeersProps {
  topBeers: Beer[];
  beersIncluded: {[key: string]: Brewery};
}

const TopBeers = ({topBeers, beersIncluded}: ITopBeersProps) => {
  return (
    <div className="top-beers">
      <div className="manager-page__top-wrapper">
        <div className="manager-page__top-ten">
          {topBeers.map(({id, attributes: {name, beer_logo, brewery_id, abv}}) => {
            const brewery = beersIncluded[brewery_id];

            return (
              <TopBeer key={id} name={name} beerLogo={beer_logo} abv={abv} breweryName={brewery?.attributes?.name} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TopBeers;
